import { render, staticRenderFns } from "./ICPCModal.vue?vue&type=template&id=081a5066"
import script from "./ICPCModal.vue?vue&type=script&lang=js"
export * from "./ICPCModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports